module.exports = __webpack_public_path__ + "media/images/icon-login-kakao@3x-11a582cd8061d83cdec3fe1fc951c738.png";